<ng-container *transloco="let t; read: 'findMyAgent.buying'">
  <label class="text-heading-2 text-steel-100 mb-4 block">{{ t('title') }}</label>
  <p>{{ t('body') }}</p>
  <a class="mt-8" href="/" mat-flat-button color="primary">{{ t('cta') }}</a>
</ng-container>
